








import {Component, Prop, Vue} from 'vue-property-decorator';
import {deleteFacebookPixel} from '@/services/FacebookPixelService';
import {IFacebookPixel} from '@/models/IFacebookPixel';
import {Confirm} from '@/decorators/ConfirmDialogDecorator';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({})
export default class RemoveFacebookPixelBtn extends Vue {
  @Prop() facebookPixel!: IFacebookPixel;
  loading: boolean = false;

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Confirm('Confirmation', 'Are you sure?')

  async submit() {
    try {
      this.loading = true;
      const success = await deleteFacebookPixel(this.organizationId, this.shopId, this.facebookPixel.id);
      if (success) {
        this.$emit('delete');
      }
    } finally {
      this.loading = false;
    }
  }
}
